import {NgModule} from '@angular/core';

import {ShareModule} from '@share/share.module';
import {LieuComponent} from './lieu.component';
import {LieuSelectionComponent} from './selection/lieu-selection.component';
import {LieuGeolocalisationListComponent} from './selection/geolocalisation/lieu-geolocalisation-list.component';
import {LieuService} from "./lieu.service";
import {LieuAdresseListComponent} from "./selection/adresse/lieu-adresse-list.component";
import {LieuEtablissementListComponent} from "./selection/etablissement/lieu-etablissement-list.component";
import {LieuLocalisationComponent} from "./selection/localisation/lieu-localisation.component";
import {AdresseBaseComponent} from "@components/lieu/selection/adresse/adresses-base/adresse-base.component";
import {AdresseFiltreComponent} from "@components/lieu/selection/adresse/adresses-filtre/adresse-filtre.component";
import {AdresseService} from "@components/lieu/selection/adresse/adresse.service";
import {AdresseFiltreListItemComponent} from "@components/lieu/selection/adresse/adresses-filtre/adresse-filtre-list-item.component";
import {LieuGeolocalisationService} from "./lieu-geolocalisation.service";
import {LieuxRecentsComponent} from "@components/lieu/selection/lieux-recents/lieux-recents.component";
import {LieuxRecentsListItemComponent} from "@components/lieu/selection/lieux-recents/lieux-recents-list-item.component";

@NgModule({
    imports: [
        ShareModule,
    ],
    declarations: [
        LieuComponent,
        LieuSelectionComponent,
        LieuAdresseListComponent,
        AdresseFiltreListItemComponent,
        LieuEtablissementListComponent,
        LieuLocalisationComponent,
        LieuGeolocalisationListComponent,
        AdresseFiltreComponent,
        AdresseBaseComponent,
        LieuxRecentsComponent,
        LieuxRecentsListItemComponent,
    ],
    exports: [
        LieuComponent,
    ],
    providers: [
        LieuService,
        LieuGeolocalisationService,
        AdresseService,
    ]
})
export class LieuModule {
}